type Translate = (key: string) => string;

export const getTriggerRows = (t: Translate) => [
  { name: t('Score or limit revised'), cadence: t('On recalculation') },
  { name: t('Judgment registered'), cadence: t('Daily') },
  { name: t('New charge or UCC-1'), cadence: t('Daily') },
  { name: t('Continuation window'), cadence: t('6 months out') },
  { name: t('Accounts overdue'), cadence: t('On filing') },
  { name: t('Director or PSC change'), cadence: t('On filing') },
  { name: t('Insolvency notice'), cadence: t('Daily') },
];

export const TRIGGER_FEED = [
  { row: 0, who: 'Northfield Tooling GmbH', change: 'score cut 63 to 57' },
  { row: 1, who: 'Calder Fabrication Ltd', change: '£92,400 unsatisfied' },
  { row: 3, who: 'Northfield Precision Inc.', change: 'lapses 14 Oct' },
  { row: 4, who: 'Halden Components SA', change: '41 days overdue' },
  { row: 2, who: 'Ardenfield Materials Ltd', change: 'MR01, Lloyds Bank' },
  { row: 6, who: 'Bramwell Castings Ltd', change: 'administration notice' },
  { row: 5, who: 'Kestrel Nominees Ltd', change: 'holding 15.0% to 9.4%' },
  { row: 0, who: 'Ravenstone Logistics Ltd', change: 'limit up to £1.15M' },
  { row: 1, who: 'Marchwood Steel Ltd', change: '£17,600 satisfied' },
  { row: 2, who: 'Peregrine Tooling Inc.', change: 'UCC-1, all assets' },
  { row: 4, who: 'Ardenfield Materials Ltd', change: 'FY2025 accounts' },
  { row: 5, who: 'Northfield Precision Ltd', change: 'director appointed' },
  { row: 3, who: 'Cedarline Holdings Inc.', change: 'lapses 02 Dec' },
  { row: 6, who: 'Tarnbrook Joinery Ltd', change: 'strike-off notice' },
] as const;

export const WATCHED_ENTITIES = 412;
export const STARTING_CHANGE_COUNT = 41;
